/* @flow */
import React from 'react';

import Activity from 'entities/Activity';
import Button from 'components/Button.jsx';
import ModalTrigger from 'components/ModalTrigger.jsx';
import RSVPDialogContainer from 'payments/containers/RSVPDialogContainer.jsx';

type Props = {
  activity: Activity,
};

class ActivityConversationHeaderManageButton extends React.Component {
  props: Props;

  render() {
    const { activity, ...rest } = this.props;

    if (activity.isSender()) {
      return (
        <Button {...rest} to={`/activities/${activity.id}`}>
          Details
        </Button>
      );
    } else {
      return (
        <ModalTrigger modal={<RSVPDialogContainer activityId={this.props.activity.id} />}>
          <Button {...rest}>
            Details
          </Button>
        </ModalTrigger>
      );
    }
  }
}

export default ActivityConversationHeaderManageButton;



// WEBPACK FOOTER //
// ./src/chat/components/ActivityConversationHeaderManageButton.jsx